module.exports = __webpack_public_path__ + "static/img/06054D_22_R_20220615_fit.c5db557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06054D_22_R_20220615_fit.png
// module id = rKRk
// module chunks = 0